"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.V3URISubgraphProvider = void 0;
const uri_subgraph_provider_1 = require("../uri-subgraph-provider");
class V3URISubgraphProvider extends uri_subgraph_provider_1.URISubgraphProvider {
}
exports.V3URISubgraphProvider = V3URISubgraphProvider;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXJpLXN1YmdyYXBoLXByb3ZpZGVyLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vLi4vc3JjL3Byb3ZpZGVycy92My91cmktc3ViZ3JhcGgtcHJvdmlkZXIudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEsb0VBQStEO0FBRy9ELE1BQWEscUJBQ1gsU0FBUSwyQ0FBbUM7Q0FDVjtBQUZuQyxzREFFbUMifQ==